import ApiService from './ApiService'

export const getApiPermissionData = () => ApiService.get('/user/permissions/')
export const getApiGroupPermissionData = id => ApiService.get(`/user/group-permissions/`, { group_id: id })
export const assignPermissionApi = data => ApiService.post('/user/group-permissions/', data)
export const removePermissionApi = data => ApiService.delete(`/user/group-permissions/`, data)
